export default {
	欢迎回来: '歡迎回來',
	设置密码: '設置密碼',
}
